export const COOKIE_KEYS = {
  USER_PREFERRED_LANGUAGE: '@lcm/user-preferred-language',
  USER_NONCE: 'oprUserNonce',
} as const;
